import React from 'react';
import { Skeleton } from '@cubeyou-team/hx-react-components';

const TaxonomyExplorerItemLoader = () => {
  const speed = 2;
  return (
    <React.Fragment>
      <Skeleton speed={speed} width={640} height={58} viewBox="0 0 640 58">
        <circle cx="66" cy="30" r="20" />
        <rect x="18" y="22" rx="4" ry="4" width="14" height="16" />
        <rect x="98" y="18" rx="4" ry="4" width="40" height="8" />
        <rect x="147" y="14" rx="4" ry="4" width="40" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="300" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={640} height={58} viewBox="0 0 640 58">
        <circle cx="66" cy="30" r="20" />
        <rect x="18" y="22" rx="4" ry="4" width="14" height="16" />
        <rect x="98" y="18" rx="4" ry="4" width="40" height="8" />
        <rect x="147" y="14" rx="4" ry="4" width="40" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="180" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={640} height={58} viewBox="0 0 640 58">
        <circle cx="66" cy="30" r="20" />
        <rect x="18" y="22" rx="4" ry="4" width="14" height="16" />
        <rect x="98" y="18" rx="4" ry="4" width="40" height="8" />
        <rect x="147" y="14" rx="4" ry="4" width="40" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="270" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={640} height={58} viewBox="0 0 640 58">
        <circle cx="66" cy="30" r="20" />
        <rect x="18" y="22" rx="4" ry="4" width="14" height="16" />
        <rect x="98" y="18" rx="4" ry="4" width="40" height="8" />
        <rect x="147" y="14" rx="4" ry="4" width="40" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="120" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={640} height={58} viewBox="0 0 640 58">
        <circle cx="66" cy="30" r="20" />
        <rect x="18" y="22" rx="4" ry="4" width="14" height="16" />
        <rect x="98" y="18" rx="4" ry="4" width="40" height="8" />
        <rect x="147" y="14" rx="4" ry="4" width="40" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="300" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={640} height={58} viewBox="0 0 640 58">
        <circle cx="66" cy="30" r="20" />
        <rect x="18" y="22" rx="4" ry="4" width="14" height="16" />
        <rect x="98" y="18" rx="4" ry="4" width="40" height="8" />
        <rect x="147" y="14" rx="4" ry="4" width="40" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="210" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={640} height={58} viewBox="0 0 640 58">
        <circle cx="66" cy="30" r="20" />
        <rect x="18" y="22" rx="4" ry="4" width="14" height="16" />
        <rect x="98" y="18" rx="4" ry="4" width="40" height="8" />
        <rect x="147" y="14" rx="4" ry="4" width="40" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="140" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={640} height={58} viewBox="0 0 640 58">
        <circle cx="66" cy="30" r="20" />
        <rect x="18" y="22" rx="4" ry="4" width="14" height="16" />
        <rect x="98" y="18" rx="4" ry="4" width="40" height="8" />
        <rect x="147" y="14" rx="4" ry="4" width="40" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="300" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={640} height={58} viewBox="0 0 640 58">
        <circle cx="66" cy="30" r="20" />
        <rect x="18" y="22" rx="4" ry="4" width="14" height="16" />
        <rect x="98" y="18" rx="4" ry="4" width="40" height="8" />
        <rect x="147" y="14" rx="4" ry="4" width="40" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="210" height="8" />
      </Skeleton>
    </React.Fragment>
  );
};
export default TaxonomyExplorerItemLoader;
